<template>
  <div>
    <transition name="SelectProdutos" backdrop>
      <div class="modalListaProdutosCatalogo">
        <div class="conteudo">
          <div class="headerProdutos">
              <!-- <span>
                <img class="logo" alt="CotriDrive" :src="require('@/assets/logo.png')">
              </span> -->
              <span class="divSearch">
                <div class="button-search">
                  <input
                    id="inputBuscar"
                    v-model="data.busca"
                    title="Pesquisar produto"
                    placeholder="Pesquisar produto"
                    @keyup.enter="buscar()"/>
                  <button id="btnBuscar" alt="Buscar" @click="buscar()" >&#128269;</button>
                </div>
              </span>
              <span class="filtrar" @click="data.showFilter = true">
                <img id="filter" :src="require('@/assets/filter.png')">
              </span>
              <!-- <button class="filtrar" @click="data.showFilter = true">Filtros</button> -->
          </div>
          <nav class="action">
            <ul>
              <li class="title">Produtos</li>
              <li @click="$emit('fechar-modal-SelectProduct', data.selectedProducts)"  class="button-cancelar">CONFIRMAR</li>
              <li class="button-Rigth" @click="$emit('fechar-modal-SelectProduct')">Cancelar</li>
            </ul>
          </nav>
          <template v-if="data.produtos.length > 0">
          <div class="containerList">
            <div class="tabela">
              <table id="listaProdutos">
                <thead>
                  <tr>
                    <th>
                    </th>
                    <th class="text-left">
                      <span title="Descrição">
                        Descrição</span>
                    </th>
                    <th class="text-left">
                      <span title="Preço">
                        Preço</span>
                    </th>
                    <th>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="produto in data.produtos"
                    :key="produto.id">
                    <td class="td-img">
                      <img v-if="produto.imagem_principal" :src=produto.imagem_principal.url>
                    </td>
                    <td class="text-left">
                      <span v-html="descricao(produto)"></span>
                    </td>
                    <!-- <td class="text">{{produto.produto_estabelecimento.length > 0 ? produto.produto_estabelecimento[0].preco : (0).toFixed(2) }}</td> -->
                    <td class="text">{{preco(produto)}}</td>
                    <td class="botoes">
                      <btn-round v-bind:sinal="'-'"
                        @click="menos(produto.id)" />
                      <input type="number" @change="changeQtd(produto.id)" class="quantidade" v-model.number="produto.quantidade">
                      <btn-round v-bind:sinal="'+'"
                         @click="mais(produto.id)" /></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="pagination" v-show="data.pagination.next_page_url !== null">
             <!--  <btn-round v-bind:sinal="'&#9662;'"
              title="Ver mais"
              @click.prevent="navigate(data.pagination.current_page + 1)"
              ></btn-round> -->
              <label
                class="verMais"
               @click.prevent="navigate(data.pagination.current_page + 1)">
               Ver Mais
              </label>
            </div>
            <!-- <pagination class="pagination" v-model:source="data.pagination" v-model:from="data.page" v-on:navigate="navigate" ></pagination> -->
          </div>
          <div v-if="data.showLoader === true" class="loader"></div>
          </template>
          <template v-else>
            <div v-if="data.showLoader === true" class="loader"></div>
            <div class="empty-state">
              <img v-if="data.showLoader === false"
                  :src="require('@/assets/empty_basket.png')"
                  alt="Imagem Principal"
                  class="img-empty-state">
              <h2 id="mensagem" class="mensagem-empty-state" v-if="data.showLoader === false">{{data.mensagem}}</h2>
            </div>
          </template>
        </div>
      </div>
    </transition>
    <Suspense>
      <filter-aside v-show="data.showFilter" v-on:fechar-filterAside="data.showFilter = false" v-on:filtroCuston="filter"/>
    </Suspense>
  </div>
</template>

<script>
import { onMounted, reactive, toRefs } from '@vue/runtime-core'
import BtnRound from '../uteis/BtnRound.vue'
import FilterAside from './FilterAside.vue'
// import Pagination from '../uteis/Pagination.vue'
import axios from 'axios'
import { precoProduto } from '@/components/funcoes/precoProduto'
import { descricaoProduto } from '@/components/funcoes/descricaoProduto'

const url = process.env.VUE_APP_API_URL

export default {
  name: 'SelectProdutos',
  components: {
    BtnRound,
    FilterAside
    // Pagination
  },
  props: {
    oferta: Boolean
  },
  setup (props_, emit) {
    const data = reactive({
      produtos: [],
      selectedProducts: [],
      showFilter: false,
      showLoader: true,
      showImagemPadrao: false,
      mensagem: '',
      pagination: {},
      page: 'SelectProdutos',
      busca: '',
      currentPage: 1,
      endPoint: 'products/',
      filtros: {
        departamento: '',
        categoria: '',
        subcategoria: '',
        marca: ''
      }
    })

    onMounted(async () => {
      data.mensagem = 'Não foram encontrados produtos para a pesquisa.'
      data.endPont = 'products/'
      if (props_.oferta) {
        data.endPont = 'products/ofertas/'
        data.mensagem = 'Ofertas esgotadas! Estamos preparando novidades.'
      }
      await axios
        .get(`${url}${data.endPont}`)
        .then((response) => {
          data.produtos = response.data.data
          data.pagination = response.data
          data.produtos.forEach(element => {
            element.quantidade = 0
          })
        })
        .catch(function (error) {
          console.log(error)
          data.mensagem = 'Ocorreu um erro inesperado.'
        })
      data.showLoader = false
    })

    const validaQtd = (produto) => {
      if (produto.quantidade < 0 || (!Number.isInteger(produto.quantidade))) {
        if (produto.quantidade < 0 || (
          (produto.erp_fl_qt_decimal && produto.erp_fl_qt_decimal !== 'S') ||
          !produto.erp_fl_qt_decimal)) {
          const index = data.selectedProducts.findIndex((item) => item.id === produto.id)
          data.selectedProducts[index].quantidade = 0
        }
        if (typeof produto.quantidade === 'string') {
          const index = data.selectedProducts.findIndex((item) => item.id === produto.id)
          data.selectedProducts[index].quantidade = 0
        }
      }
    }

    const changeQtd = (proId) => {
      const index = data.produtos.findIndex((item) => item.id === proId)
      if (!data.selectedProducts.includes(data.produtos[index])) {
        data.selectedProducts.push(data.produtos[index])
      }
      validaQtd(data.produtos[index])
      if (data.produtos[index].quantidade === 0 && data.selectedProducts.includes(data.produtos[index])) {
        const indexSelect = data.selectedProducts.findIndex((item) => item.id === proId)
        data.selectedProducts.splice(indexSelect, 1)
      }
    }

    const menos = (proId) => {
      const index = data.produtos.findIndex((item) => item.id === proId)
      if (data.produtos[index].quantidade !== 0) {
        data.produtos[index].quantidade -= 1
        validaQtd(data.produtos[index])
        if (data.produtos[index].quantidade <= 0 &&
          data.selectedProducts.includes(data.produtos[index])) {
          const indexSelect = data.selectedProducts.findIndex((item) => item.id === proId)
          data.selectedProducts.splice(indexSelect, 1)
        }
      }
    }

    const mais = (proId) => {
      const index = data.produtos.findIndex((item) => item.id === proId)
      data.produtos[index].quantidade += 1
      if (!data.selectedProducts.includes(data.produtos[index])) {
        data.selectedProducts.push(data.produtos[index])
      }
    }

    const navigate = async (valor) => {
      if (data.next_page_url !== null) {
        data.currentPage = valor
        search('navigate')
      }
    }

    const buscar = async () => {
      data.currentPage = 1
      search()
    }

    const filter = async (valor) => {
      data.currentPage = 1
      data.showFilter = false
      data.filtros = valor
      search()
    }

    const search = async (from = '') => {
      data.showLoader = true
      data.mensagem = 'Não foram encontrados produtos para a pesquisa.'
      data.endPont = 'products/'
      if (props_.oferta) {
        data.endPont = 'products/ofertas/'
      }
      await axios
        .get(`${url}${data.endPont}`, {
          params: {
            page: data.currentPage,
            busca: data.busca,
            departamento: data.filtros.departamento,
            categoria: data.filtros.categoria,
            subcategoria: data.filtros.subcategoria,
            marca: data.filtros.marca
          }
        })
        .then((response) => {
          if (from === 'navigate') {
            data.produtos.push(...response.data.data)
          } else {
            data.produtos = response.data.data
          }
          data.pagination = response.data
          data.produtos.forEach(element => {
            if (!element.quantidade) {
              element.quantidade = 0
            }
          })
          data.showLoader = false
        })
        .catch(function (error) {
          console.log(error)
          data.mensagem = 'Ocorreu um erro inesperado.'
          data.showLoader = false
        })
    }

    const descricao = (produto) => {
      return descricaoProduto(produto)
    }

    const preco = (produto) => {
      return precoProduto(produto)
    }

    return { data, changeQtd, menos, mais, onMounted, navigate, buscar, filter, search, descricao, preco }
  }
}
</script>

<style lang="scss">
  .modalListaProdutosCatalogo {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
    overflow-y: initial !important;
  }

  .modalListaProdutosCatalogo:target {
    opacity: 1;
    pointer-events: auto;
  }
  .modalListaProdutosCatalogo .conteudo {
    width: clamp(80%, 90%, 516px);
    height: clamp(90%, 100%, 516px);
    position: relative;
    margin: 1% auto;
    background: rgba(255, 255, 255, 0.712);
    border-radius: 15px;
    transition: opacity 3s ease !important;
    display: flex;
    flex-flow: column wrap;
    height: 100%;
    overflow-y: initial !important;
  }

  .modalListaProdutosCatalogo .headerProdutos {
    background: none;
    display: grid;
    width: 100%;
    height: 5.3rem;
    align-content: center;
    align-items: center;
    grid-template-columns: 3fr 1fr;
    grid-column-gap:5px;
    padding: auto;
  }

  @media only screen and (min-width: 516px) {
   .modalListaProdutosCatalogo .headerProdutos {
      background: none;
      display: grid;
      width: 100%;
      height: 5.3rem;
      align-content: center;
      align-items: center;
      grid-template-columns: 3fr 1fr;
      grid-column-gap:5px;
      padding: auto;
   }
  }

  .modalListaProdutosCatalogo-enter {
    opacity: 0;
  }

  .modalListaProdutosCatalogo-leave-active {
    opacity: 0;
  }

  .modalListaProdutosCatalogo-enter .modal-container,
  .modalListaProdutosCatalogo-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  .headerProdutos {
    position: relative;
    display: table;
    width: 100%;
  }

  .divSearch {
    display: flex;
    float: left;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%!important;
    margin: auto;

    .button-search {
      border: 1.5px solid;
      border-color: #C2171A;
      border-radius: 20px;
      background-color: #f2f2f2;
      margin: 0.8rem;
      height: 3rem;
      width: 100%;
      max-width: 40rem;
      display: table;

      #inputBuscar {
        border: none;
        background-color:#c2171a00;
        display: inline;
        width: clamp(5rem, 33vw, 20rem); /*clamp(20rem, 5%, 20rem);*/
        margin: 0.5rem;
      }
      #btnBuscar {
        display: flex;
        background: none;
        float: right;
      }
    }
  }

  .filtrar {
    display: table-column-group;
    float: center;
    width: 70%!important;
    max-width: 10rem;
    margin: auto;
    img {
      float: center;
      cursor: pointer;
      position: relative;
      vertical-align: middle;
      height: 3.5rem;
    }
  }

  .containerList {
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 30px rgba(211, 211, 211, 0.25);
    max-height: 80%;
    height: auto;
    width: 100%;
  }

  div.tabela{
    background: #fff;
    float: left;
    position: relative;
    width: 100%;
    height: auto;
    max-height: calc(100vh - 11rem);
    overflow-y: auto;
    table{
      overflow-y: auto;
      border-collapse: collapse;
      border-spacing: 0;
      width: 100%;
      height: auto;
      border: 1px solid rgba(221, 221, 221, 0);
    }

    thead th {
      position: sticky;
      top: 0;
      background-color: rgb(187, 187, 187);
      text-align: left;
      padding: 5px;
    }

    tbody td {
      position: relative;
      font-size: 1rem;
      text-align: left !important;
      padding: 1%;

      span {
        position: relative;
        align-self: center;
        color: black;
        white-space: inherit;
      }
    }

    tbody td.botoes {
      display:inline-block;
      position: relative;

    }

    tbody td.td-img {
      text-align: left !important;
      margin-right: 0;

      img {
        align-content: center;
        margin: 0.2rem;
        max-width: clamp(3rem, 5rem, 7rem);
        min-width: 2rem;
      }
    }

    tbody tr:nth-child(even) {
      background-color: #f2f2f2;
    }

    tbody tr:hover {
      background-color: #FFEC00 !important;
    }
  };

  @media only screen and (min-width: 516px) {
    div.tabela{
      max-height: calc(100vh - 14rem);
    }
  }

  nav.action {
    background: #C2171A;
    position: relative;
    color: #fff;
    width: fill-available;
    margin: 0;
    padding: 0;

    ul {
      margin: 0;
      list-style: none;
    }
    ul li {
      display: inline-flex;
      flex-wrap: wrap;
      font-size: 0.8rem;
      text-align: center;
      margin: 10px;
    }
    /* For width 400px and larger: */
    @media only screen and (min-width: 516px) {
      ul li {
        float:left;
        font-size: 1.5rem;
        display: inline-flex;
      }
    }
    li.title {
      display: none;
    }
    li.button-Rigth {
      right: 0;
      cursor: pointer;
    }
    li.button-Rigth:hover {
      color: #FFEC00;
    }
    li.button-cancelar {
      float: right;
      cursor: pointer;
    }
    li.button-cancelar:hover  {
      color: #FFEC00;
    }
    /* For width 400px and larger: */
    @media only screen and (min-width: 516px) {
      li.title {
        float: left;
        display: flex;
      }
      li.button-cancelar {
        float: right;
        cursor: pointer;
      }
      li.button-Rigth {
        float: right;
        cursor: pointer;
      }
    }
  }

  .empty-state {
   display: block;
   width: 80%;
   margin: auto;
  }

  .img-empty-state {
    display: flex;
    width: 60%;
    max-width: 300px;
    height: auto;
    margin: auto;
  }

  .mensagem-empty-state {
    margin: 10%;
  }

  .pagination {
    position:relative;
    align-content: center;

    .verMais {
      font-weight: 600;
      text-align: center;
      color: #C2171A;
      margin: auto;
      cursor: pointer;
    }
  }

  .loader {
    position:absolute;
    display: flex;
    left: 43%;
    bottom: 50%;
    align-self: center;
    vertical-align: middle;
    border: 16px solid #fff6aa;
    border-radius: 50%;
    border-top: 16px solid #ffa6a6;
    width: 5rem;
    height: 5rem;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
  }

  /* Safari */
  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
</style>
